export const TARGET_SELF = '_self';
export const TARGET_BLANK = '_blank';
